import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Drawer, Grid, Typography, Chip, makeStyles, Button, Divider } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import RoomIcon from "@material-ui/icons/Room";
import { SearchSelect, SubmitButton, Can } from "../../../../";
import _ from "lodash";
import ReactMapGL, { Marker, GeolocateControl, FlyToInterpolator, NavigationControl } from "react-map-gl";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconStaff: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificate: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificateLink: {
      textDecoration: "none",
      color: "inherit"
    },
    text: {
      fontFamily: theme.typography.fontFamily
    }
  };
});

var StaffDrawerShift = function StaffDrawerShift(props) {
  // console.log("StaffDrawerShift props", props);
  var _useState = useState({
    latitude: 40.416775,
    longitude: -3.70379,
    zoom: 5
  }),
      _useState2 = _slicedToArray(_useState, 2),
      viewport = _useState2[0],
      setViewport = _useState2[1];

  var classes = useStyles();
  var initialValues = {
    comments: ""
  };
  var shiftSchema = Yup.object().shape({
    comments: Yup.string().required("Campo obligatorio")
  });
  useEffect(function () {
    props.data && props.data.checkIn && props.data.checkIn.coords && setViewport({
      latitude: props.data.checkIn.coords.latitude,
      longitude: props.data.checkIn.coords.longitude,
      zoom: 15
    }); // console.log("viewport", viewport);
  }, [props.data]);
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: props.toggleDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, props.data ? props.data.day : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.check_in || "Check in" : "Check in" : "Check in"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data ? props.data.checkIn ? props.data.checkIn.date || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.check_out || "Check out" : "Check out" : "Check out"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, " ", props.data ? props.data.checkOut ? props.data.checkOut.date || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ReactMapGL, Object.assign({}, viewport, {
    width: "100%",
    height: "200px",
    mapboxApiAccessToken: props.mapboxApiAccessToken,
    onViewportChange: function onViewportChange(viewport) {
      // console.log("onViewportChange", viewport);
      setViewport(_objectSpread({}, viewport));
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      right: 0
    }
  }, /*#__PURE__*/React.createElement(NavigationControl, null)), props.data && props.data.checkIn && props.data.checkIn.coords && /*#__PURE__*/React.createElement(Marker, {
    latitude: props.data.checkIn.coords.latitude,
    longitude: props.data.checkIn.coords.longitude,
    offsetLeft: -20,
    offsetTop: -10
  }, /*#__PURE__*/React.createElement(RoomIcon, {
    fontSize: "large",
    color: "primary"
  })), props.data && props.data.checkOut && props.data.checkOut.coords && /*#__PURE__*/React.createElement(Marker, {
    latitude: props.data.checkOut.coords.latitude,
    longitude: props.data.checkOut.coords.longitude,
    offsetLeft: -20,
    offsetTop: -10
  }, /*#__PURE__*/React.createElement(RoomIcon, {
    fontSize: "large",
    color: "secondary"
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data ? props.data.comments ? props.data.comments.franchise ? {
      comments: props.data.comments.franchise
    } || initialValues : initialValues : initialValues : initialValues,
    validationSchema: shiftSchema,
    onSubmit: function onSubmit(values) {
      props.toggleDrawer();
      props.data.handleSubmit(props.data ? props.data._id : null, values);
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        component: TextField,
        label: props.translation ? props.translation.inputs ? props.translation.inputs.comments || "comments" : "comments" : "comments",
        name: "comments",
        multiline: true,
        rows: 4,
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save")));
    }
  }))));
};

export { StaffDrawerShift };